<template>
  <div>
    <template v-if="aloneData.length != 0">
      <div class="new-one-wrap" v-for="(item, index) in aloneData" :key="index">
        <!-- <div :class="item.is_top == 0 ? 'new-one-item' : 'new-one-item-top'"> -->
        <div v-if="!item.ExhibitionId" @click="adPage" style="margin-top: 20px;">
          <a href="adintroduce.html" >
            <img src="../../../assets/img/ad_kong.jpg" style="width: 100%;height: 340px;border-radius: 10px;">
          </a>
        </div>

        <div v-else class="new-one-item">
          <!-- <div>{{item.broadcast_logo}}</div> -->
          <div
            v-if="item.is_top == 1"
            style="position: absolute;left: -7px;top: -7px;z-index: 1;"
          >
<!--            <img src="../../../assets/icon_recommend.png" alt=""/>-->
          </div>
          <div
            class="new-one-item-img-wrap"
            style="position: absolute; width: 60%; left:20%"
          >
            <img
              v-if="item.company_logo_url"
              class="new-one-item-title-img"
              :src="item.company_logo_url"
              alt=""
              style="height: 80px; "
            />
            <img
              v-else
              class="new-one-item-title-img"
              src="../../../assets/img_default_logo.png"
              alt=""
              style="height: 80px; "
            />
          </div>

          <div v-if="lan == 'ch'" style="height: 130px; margin-top: 100px">
            <div
              class="new-one-item-company"
              style="text-align: left;font-size:16px;
        color: #000; font-weight: bold; margin: 10px auto; padding-top: 30px; width: 80%; height:45px;"
            >
              {{ item.company }}
            </div>

            <div
              class="new-one-item-userpost"
              style="display:flex; width: 80%; padding-top: 20px; flex-direction: column">
              <p style="width: 100%">
                <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">所在地：{{ item.location }}</div>
                <div>状态：{{ item.broadcast_state }}</div>
            </div>
            <!-- <div class="new-one-item-introduce">{{item.company_desc}}</div> -->
          </div>
<!--          <div v-if="lan == 'en'" style="height: 130px; margin-top: 100px">-->
<!--            <div-->
<!--              class="new-one-item-company"-->
<!--              style="text-align: left;font-size:16px;-->
<!--        color: #000; font-weight: bold; margin: 10px auto; padding-top: 30px; width: 80%; height:45px;"-->
<!--            >-->
<!--              {{ item.company_en }}-->
<!--            </div>-->

<!--            <div-->
<!--              class="new-one-item-userpost"-->
<!--              style="display:flex;width: 80%; padding-top: 20px; flex-direction: column"-->
<!--            >-->
<!--              <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">Class：{{ item.broadcast_class_en }}</div>-->
<!--              <div>State：{{ item.broadcast_state }}</div>-->
<!--            </div>-->
<!--            &lt;!&ndash; <div class="new-one-item-introduce">{{item.company_desc_en}}</div> &ndash;&gt;-->
<!--          </div>-->
          <div
            :class="
              item.is_top == 0
                ? 'new-one-item-seebtn'
                : 'new-one-item-seebtn-top'
            "
            @click="showParticipants(item, index)"
          >
            <p v-if="lan == 'ch'" style="font-size: 18px;">查看企业</p>
<!--            <p v-if="lan == 'en'">Exhibitors</p>-->
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        style="height: 400px; text-align: center; line-height: 300px; color: #fff;
         font-size: 22px;"
        class="bjWu"
      >
        <span style="color: #919090;position: relative;top: 190px;">未找到你要搜索的岗位</span>
      </div>
    </template>
  </div>
</template>

<script>
import { ExhibitionTypeEnum } from "../../../common/constant/exhibition";
import errorImage from "../../../assets/error_room.png";
import { stateEnum } from "./enum";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token"]),
  },
  props: {
    language: {
      type: Object,
      default: () => {},
    },
    lan: {
      type: String,
    },
    aloneData: {
      type: Array,
      default: () => [],
    },
    exhState: {}
  },
  data() {
    return {
      ExhibitionTypeEnum,
      stateEnum,
      errorImage,
      isMobileBool: true,
      showHint: false,
      showBtn: false,
      showBtnShow: false,
    };
  },
  methods: {
    showParticipants(item, index) {
      this.$emit("showParticipants", [item, index]);
    },
    adPage(){

    }
  },
  mounted() {
    console.log("11111:=" + this.aloneData);
  },
  created() {},
};
</script>

<style scoped>
.card-img {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  left: 0;
}
.alone_content {
  padding: 20px 20px 0 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
}
.alone_left {
  display: flex;
  flex-direction: column;
  display: -webkit-flex;
  align-items: center;
  overflow: hidden;
}
.alone_right {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  margin-left: 20px;
  width: 985px;
}
.always_main_title {
  font-family: MicrosoftYaHei-Bold;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 17px;
  color: #0f408a;
}
.broadcast_information {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  margin-top: 20px;
  font-size: 14px;
  color: #424242;
  font-weight: normal;
  font-stretch: normal;
  font-family: MicrosoftYaHei;
}
.profile {
  /* margin-top: 20px; */
  text-indent: 2em;
  font-family: MicrosoftYaHeiLight;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0;
  color: #a1a1a1;
  word-wrap: break-word;
}
.info_col {
  max-width: 285px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.people_number {
  color: #424242;
  font-size: 14px;
}
.alone_btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-div {
  cursor: pointer;
  float: right;
  font-size: 14px;
  font-weight: 600;
  margin: 25px 0 25px;
  color: rgb(15, 64, 138);
}
.btn-div span {
  padding-top: 5px;
}
.btn-div img {
  width: 15px;
  height: 15px;
  vertical-align: middle;
  margin-left: 2px;
  /* margin-top: -5px; */
}
.ellipsis-p {
  width: 985px;
  /* overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; */

  position: relative;
  line-height: 24px;
  max-height: 100%;
  overflow: hidden;
}

.ellipsis-p::after {
  content: "...";
  position: absolute;
  bottom: 0;
  right: 0px;
  padding: 0 30px 0 0px;
  background: -webkit-linear-gradient(left, transparent, #fff 40%);
  background: -o-linear-gradient(right, transparent, #fff 40%);
  background: -moz-linear-gradient(right, transparent, #fff 40%);
  background: linear-gradient(to right, transparent, #fff 40%);
}
.ellipsis-p-m {
  width: 985px;
  /* overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; */

  position: relative;
  line-height: 24px;
  max-height: 100%;
  overflow: hidden;
}
.ellipsis-p-m::after {
  content: "...";
  position: absolute;
  bottom: 5px;
  right: 0px;
  padding: 0 30px 0 0px;
  margin-left: -10px;
  font-size: 24px;
  background: #fff;
  border-radius: 10px;
  /* background: -webkit-linear-gradient(left, transparent, #fff 40%);
      background: -o-linear-gradient(right, transparent, #fff 40%);
      background: -moz-linear-gradient(right, transparent, #fff 40%);
      background: linear-gradient(to right, transparent, #fff 40%); */
}
.new-one-wrap {
  width: 18.6%;
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
}
.new-one-wrap:first-child {
  margin-left: 0;
}
.new-one-wrap:nth-child(5) {
  margin-right: 0;
}
.new-one-wrap:nth-child(6) {
  margin-left: 0;
}
.new-one-wrap:last-child {
  margin-right: 0;
}

/* .new-one-wrap:nth-child(3n-1){
    margin-left: 20px;
    margin-right: 20px;
  } */

.new-one-item-top {
  width: 98%;
  min-height: 311px;
  /*min-height: 400px;*/
  background: #fff;
  margin-top: 20px;
  padding: 20px 0 10px;
  float: left;
  border-radius: 10px;
  position: relative;
  z-index: 4;
  border: 5px solid #fb9120;
}
.new-one-item {
  width: 100%;
  min-height: 311px;
  /*min-height: 400px;*/
  background: #fff;
  margin-top: 20px;
  padding: 20px 0 10px;
  float: left;
  border-radius: 10px;
  position: relative;
  z-index: 4;
}
.new-one-item-img-wrap {
  width: 80px;
  height: 80px;
  text-align: center;
  margin: auto;
  position: relative;
}
.new-one-item-title-img {
  /*width: 100%;*/
  max-width: 100%;
  height: auto;

  vertical-align: middle;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  /* height: 150px; */
}
.new-one-item-title {
  width: 90%;
  margin: 20px auto 0;
  font-size: 1.1rem;
  font-weight: bold;
  min-height: 40px;
  overflow: hidden;
}
.new-one-item-title p {
  line-height: 1.5;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.new-one-item-title-recommend {
  font-size: 0.8rem;
  padding: 1px 10px;
  font-weight: 100;
  color: #fff;
  background: #0f408a;
  margin-right: 5px;
}
.new-one-item-company {
  width: 90%;
  min-height: 40px;
  margin: 5px auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #a1a1a1;
}
.new-one-item-userpost {
  width: 90%;
  margin: 5px auto;
  min-height: 38px;
  /* padding-bottom: 10px; */
  /* border-bottom: 1px solid #eceeec; */
  color: #0c6dce;
}
.new-one-item-introduce {
  width: 90%;
  min-height: 72px;
  text-align: justify;
  margin: 0 auto;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  color: #a1a1a1;
}

.new-one-item-seebtn {
  width: 90%;
  margin: 20px auto;
  text-align: center;
  /*background: linear-gradient(0deg, rgb(0, 180, 251), rgb(0, 104, 234));*/
  background: #0071ff;
  color: #fff;
  padding: 10px 0;
  cursor: pointer;
  border-radius: 5px;
}
.bjWu {
  background: url("../../../assets/img/26.png");
}
.new-one-item-seebtn-top {
  width: 90%;
  margin: 20px auto;
  text-align: center;
  /*background: linear-gradient(0deg, rgb(236, 141, 55), rgb(239, 106, 40));*/
  background: #0071ff;
  color: #fff;
  padding: 10px 0;
  cursor: pointer;
  border-radius: 5px;
}

</style>
